import React, { useContext, useEffect, useState, useRef } from 'react'
import './NavLinks.css'
import './Dropdown.css'
import { NavLink, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../shared/context/auth-context'
import NavLinksScheduleDropdown from './NavLinksScheduleDropdown'
import NavLinksHomeDropdown from './NavLinksHomeDropdown'
//import { useAuth } from '../../shared/hooks/auth-hook'

const NavLinks = (props) => {
	const auth = useContext(AuthContext)
	const [loggedOut, setLoggedOut] = useState(false)
	//const { logout } = useAuth()
	let navigate = useNavigate()
	//
	//
	//
	//
	//
	const dropdownRef = useRef(null) // Create a reference for dropdown container
	const homeDropdownRef = useRef(null)
	const [isMenuDropDownOpen, setMenuDropDownOpen] = useState(false)
	const [isHomeMenuDropDownOpen, setHomeMenuDropDownOpen] = useState(false)
	// Function to close dropdown
	const closeHoverMenu = () => {
		setMenuDropDownOpen(false)
	}
	const closeHoverHomeMenu = () => {
		setHomeMenuDropDownOpen(false)
	}
	//
	//
	//
	//

	useOnHoverOutside(dropdownRef, closeHoverMenu) // Call the hook

	useHomeOnHoverOutside(homeDropdownRef, closeHoverHomeMenu) // Call the hook

	//
	//
	//
	//
	//
	const logoutStuff = () => {
		//console.log('inside logoutStuff')
		setLoggedOut(true)
	}

	if (loggedOut) {
		//console.log('user is logged out')
		navigate('/admin/login')
		auth.logout()
	}

	//*********************************************************************** */
	//
	//	Leagues
	//
	//*********************************************************************** */
	function myFunction() {
		document.getElementById('myDropdown').classList.toggle('show')
	}

	window.onclick = function (event) {
		if (!event.target.matches('.dropbtn')) {
			var dropdowns = document.getElementsByClassName('dropdown-content')
			var i
			for (i = 0; i < dropdowns.length; i++) {
				var openDropdown = dropdowns[i]
				if (openDropdown.classList.contains('show')) {
					openDropdown.classList.remove('show')
				}
			}
		}
	}

	//*********************************************************************** */
	//
	//	Players
	//
	//*********************************************************************** */
	function myFunction2() {
		document.getElementById('myDropdown2').classList.toggle('show')
	}

	window.onclick = function (event) {
		if (!event.target.matches('.dropbtn')) {
			var dropdowns = document.getElementsByClassName('dropdown-content')
			var i
			for (i = 0; i < dropdowns.length; i++) {
				var openDropdown = dropdowns[i]
				if (openDropdown.classList.contains('show')) {
					openDropdown.classList.remove('show')
				}
			}
		}
	}

	//*********************************************************************** */
	//
	//	Games
	//
	//*********************************************************************** */
	function myFunction3() {
		document.getElementById('myDropdown3').classList.toggle('show')
	}

	window.onclick = function (event) {
		if (!event.target.matches('.dropbtn')) {
			var dropdowns = document.getElementsByClassName('dropdown-content')
			var i
			for (i = 0; i < dropdowns.length; i++) {
				var openDropdown = dropdowns[i]
				if (openDropdown.classList.contains('show')) {
					openDropdown.classList.remove('show')
				}
			}
		}
	}

	//
	//
	//
	//
	//
	function useOnHoverOutside(ref, handler) {
		useEffect(() => {
			const listener = (event) => {
				if (!ref.current || ref.current.contains(event.target)) {
					return
				}
				handler(event)
			}
			document.addEventListener('mouseover', listener)
			return () => {
				document.removeEventListener('mouseout', listener)
			}
		}, [ref, handler])
	}
	//
	//
	//
	function useHomeOnHoverOutside(ref, handler) {
		useEffect(() => {
			const listener = (event) => {
				if (!ref.current || ref.current.contains(event.target)) {
					return
				}
				handler(event)
			}
			document.addEventListener('mouseover', listener)
			return () => {
				document.removeEventListener('mouseout', listener)
			}
		}, [ref, handler])
	}
	//
	//
	//
	//
	//
	//

	return (
		<ul className='nav-links'>
			{/* {auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/league/new' exact>
						NEW LEAGUE
					</NavLink>
				</li>
			)} */}
			{/* <h2>|</h2> */}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/leagues/current' exact>
						LEAGUES
					</NavLink>
				</li>
			)}
			{/* <h2>|</h2> */}
			{/* {auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/leagues/archive' exact>
						ARCHIVED LEAGUES
					</NavLink>
				</li>
			)} */}
			{/* <h2>|</h2> */}
			{/* {auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/tournaments' exact>
						TOURNAMENTS
					</NavLink>
				</li>
			)} */}
			{/* {auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/newPlayer' exact>
						ADD PLAYERS
					</NavLink>
				</li>
			)} */}
			{/* <h2>|</h2> */}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/getAllPlayers' exact>
						PLAYERS
					</NavLink>
				</li>
			)}
			{/* <h2>|</h2> */}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/games/new' exact>
						ADD GAMES
					</NavLink>
				</li>
			)}
			{/* <h2>|</h2> */}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/events/new' exact>
						ADD EVENT
					</NavLink>
				</li>
			)}
			{/* <h2>|</h2> */}

			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/masterSchedule' exact>
						SCHEDULE
					</NavLink>
				</li>
			)}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/venues' exact>
						VENUES
					</NavLink>
				</li>
			)}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/photos' exact>
						PHOTOS
					</NavLink>
				</li>
			)}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/allVideos' exact>
						VIDEOS
					</NavLink>
				</li>
			)}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/news' exact>
						NEWS
					</NavLink>
				</li>
			)}
			{/* {auth.isLoggedIn && (
				<li>
					<div ref={dropdownRef}>
						<NavLink
							to='#'
							id='scheduleButton'
							onMouseOver={() => setMenuDropDownOpen(true)} //use mouseover event to show dropdown
							// style={{ border: 'none', background: '#92562e' }}
						>
							SCHEDULE
						</NavLink>
						{isMenuDropDownOpen && <NavLinksScheduleDropdown />}
					</div>
				</li>
			)} */}
			{auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/howto' exact>
						HOW-TO
					</NavLink>
				</li>
			)}
			<li>
				<NavLink to='/' exact>
					HOME
				</NavLink>
			</li>
			{/* {auth.isLoggedIn && (
				<li>
					<NavLink to='/admin/personnel' exact>
						PERSONNEL
					</NavLink>
				</li>
			)} */}
			{/* {auth.isLoggedIn && (
				<li>
					<div ref={homeDropdownRef}>
						<NavLink
							to='#'
							id='scheduleButton'
							onMouseOver={() => setHomeMenuDropDownOpen(true)} //use mouseover event to show dropdown
							// style={{ border: 'none', background: '#92562e' }}
						>
							HOME
						</NavLink>
						{isHomeMenuDropDownOpen && <NavLinksHomeDropdown />}
					</div>
				</li>
			)} */}
			<li>
				<button onClick={logoutStuff} style={{ border: 'none' }}>
					LOGOUT
				</button>
				{/* <NavLink to='/'>HOME</NavLink> */}
			</li>
			<li></li>
		</ul>
	)
}

export default NavLinks
